var _path, _path2, _g, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g3, _path15, _path16, _g4, _path17, _path18, _path19, _path20, _g5, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtualMachines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 164,
    viewBox: "0 0 156 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82052 122.725L1.96449 121.063C0.861376 120.413 0.181371 119.053 0.16626 117.119L3.02229 118.781C3.02229 120.716 3.71741 122.091 4.82052 122.725Z",
    fill: "#37404A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_124_6596",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 117,
    width: 5,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82052 122.725L1.96449 121.063C0.861376 120.413 0.181371 119.053 0.16626 117.119L3.02229 118.781C3.02229 120.716 3.71741 122.091 4.82052 122.725Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_124_6596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.82052 122.725L1.96449 121.063C0.861376 120.413 0.181371 119.053 0.16626 117.119L3.02229 118.781C3.02229 120.716 3.71741 122.091 4.82052 122.725Z",
    fill: "#37404A"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02223 118.781L0.166201 117.119L0 59.2737L2.85603 60.9359L3.02223 118.781Z",
    fill: "#37404A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99116 50.3128L6.13513 48.6506L88.9291 0.854004L91.8003 2.51624L8.99116 50.3128Z",
    fill: "#37404A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85603 60.9357L0 59.2735C0 55.3597 2.73512 50.6148 6.13512 48.6504L8.99115 50.3126C5.59115 52.2771 2.85603 57.022 2.85603 60.9357Z",
    fill: "#37404A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_124_6596",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 48,
    width: 9,
    height: 13
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85603 60.9357L0 59.2735C0 55.3597 2.73512 50.6148 6.13512 48.6504L8.99115 50.3126C5.59115 52.2771 2.85603 57.022 2.85603 60.9357Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_124_6596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.85603 60.9356L0 59.2734C0 57.7774 0.392846 56.1605 1.08796 54.6191L3.94399 56.2814C3.26399 57.8227 2.85603 59.4396 2.85603 60.9356Z",
    fill: "#37404A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94392 56.2815L1.08789 54.6193C1.61678 53.4255 2.32709 52.262 3.1582 51.2646L6.01414 52.9269C5.18303 53.9393 4.47281 55.0878 3.94392 56.2815Z",
    fill: "#37404A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01426 52.9269L3.15833 51.2646C4.03477 50.1918 5.04718 49.2851 6.13518 48.6655L8.99121 50.3278C7.9032 50.9473 6.89071 51.854 6.01426 52.9269Z",
    fill: "#37404A"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8002 2.51602C95.2002 0.551573 97.9656 2.12311 97.9807 6.0369L98.1469 63.8824C98.1469 67.7811 95.4118 72.5411 92.0118 74.5056L9.20267 122.317C5.80266 124.282 3.03729 122.695 3.03729 118.796L2.87109 60.9508C2.87109 57.0371 5.60621 52.2922 9.00622 50.3277L91.8153 2.51602H91.8002Z",
    fill: "#242A31"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7469 63.8824C94.7469 66.5571 92.6313 70.2291 90.3042 71.574L7.49509 119.386C7.02664 119.658 6.7093 119.733 6.54308 119.763C6.48263 119.612 6.40702 119.31 6.39191 118.781V118.252L6.22571 60.9357C6.22571 58.2611 8.34127 54.589 10.6684 53.2442L92.7068 5.88581L93.4775 5.43247C93.9611 5.16047 94.2784 5.0698 94.4446 5.05469C94.5051 5.2058 94.5806 5.50801 94.5957 6.0369L94.762 63.8824H94.7469Z",
    fill: "#10191B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8731 63.1872C92.8731 65.8619 90.7575 69.5339 88.4304 70.8788L6.39191 118.237L6.22571 60.9205C6.22571 58.2459 8.34127 54.5739 10.6684 53.229L92.7068 5.87061L92.8731 63.1872Z",
    fill: "#ED1C24"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4747 44.132L6.28613 76.6513L6.31638 88.9668L42.2356 35.02L26.4747 44.132Z",
    fill: "#242A31"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36182 104.275L6.4071 118.237L10.8195 115.684L82.0687 12.021L58.2082 25.8024L6.36182 104.275Z",
    fill: "#242A31"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3113 0.415684L96.1674 2.0779C95.0492 1.42812 93.4927 1.51878 91.7851 2.50101L88.9291 0.838795C90.6366 -0.14343 92.1931 -0.234095 93.3113 0.415684Z",
    fill: "#37404A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.992 107.267V110.576C155.992 111.846 155.146 113.13 153.469 114.097V110.788C155.146 109.821 155.992 108.536 155.992 107.267Z",
    fill: "#98A4E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_124_6596",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 107,
    width: 3,
    height: 8
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.992 107.267V110.576C155.992 111.846 155.146 113.13 153.469 114.097V110.788C155.146 109.821 155.992 108.536 155.992 107.267Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_124_6596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.992 107.267V110.576C155.992 110.969 155.902 111.377 155.735 111.755V108.446C155.902 108.053 155.992 107.66 155.992 107.267Z",
    fill: "#98A4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.751 108.446V111.755C155.388 112.616 154.617 113.432 153.469 114.097V110.788C154.632 110.123 155.388 109.307 155.751 108.446Z",
    fill: "#98A4E0"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04443 129.253V125.944C6.04443 127.244 6.90579 128.528 8.61335 129.525V132.835C6.89068 131.853 6.04443 130.553 6.04443 129.253Z",
    fill: "#98A4E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_124_6596",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 125,
    width: 3,
    height: 8
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04443 129.253V125.944C6.04443 127.244 6.90579 128.528 8.61335 129.525V132.835C6.89068 131.853 6.04443 130.553 6.04443 129.253Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_124_6596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.61335 129.525V132.835C6.89068 131.853 6.04443 130.553 6.04443 129.253V125.944C6.04443 127.244 6.90579 128.528 8.61335 129.525Z",
    fill: "#98A4E0"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M153.484 110.787L153.469 114.097L71.2037 161.893L71.2189 158.599L153.484 110.787Z",
    fill: "#98A4E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9485 158.599L58.9334 161.893L8.59814 132.835L8.61327 129.525L58.9485 158.599Z",
    fill: "#98A4E0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2189 158.599V161.908C67.834 163.873 62.3335 163.873 58.9486 161.908V158.599C62.3486 160.564 67.8491 160.564 71.2189 158.599Z",
    fill: "#98A4E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_124_6596",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 158,
    width: 14,
    height: 6
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2189 158.599V161.908C67.834 163.873 62.3335 163.873 58.9486 161.908V158.599C62.3486 160.564 67.8491 160.564 71.2189 158.599Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_124_6596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.2189 158.599V161.908C69.4811 162.906 67.1993 163.404 64.9326 163.374V160.065C67.2144 160.095 69.4962 159.596 71.2189 158.599Z",
    fill: "#98A4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9328 160.065V163.374C62.7568 163.359 60.5959 162.86 58.9337 161.908V158.599C60.5959 159.551 62.7568 160.05 64.9328 160.065Z",
    fill: "#98A4E0"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M153.438 103.685C156.838 105.65 156.854 108.823 153.484 110.787L71.2187 158.599C67.8338 160.564 62.3484 160.564 58.9484 158.599L8.61317 129.54C5.21316 127.576 5.19801 124.403 8.56779 122.438L90.8329 74.6264C94.2027 72.662 99.7031 72.662 103.103 74.6264L153.438 103.685Z",
    fill: "#CDDCFB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136.575 99.5751C136.408 100.436 135.759 101.268 134.625 101.932L56.3948 147.341C53.7201 148.898 49.3681 148.898 46.6783 147.341L13.0862 127.969C12.0284 127.364 11.3938 126.609 11.152 125.823C10.7893 124.599 11.424 123.284 13.0409 122.348L91.2713 76.9386C93.9309 75.3821 98.2829 75.3821 100.973 76.9386L134.565 96.3111C136.106 97.2026 136.771 98.4115 136.544 99.5751H136.575Z",
    fill: "#98A4E0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M136.575 99.575C136.408 100.436 135.759 101.267 134.625 101.932L56.3948 147.341C53.7201 148.898 49.3681 148.898 46.6783 147.341L13.0862 127.969C12.0284 127.364 11.3938 126.609 11.152 125.823C11.3182 124.962 11.9679 124.116 13.1013 123.466L91.3318 78.0567C94.0064 76.5003 98.3433 76.5003 101.048 78.0567L134.64 97.4293C135.698 98.0337 136.333 98.7893 136.559 99.575H136.575Z",
    fill: "#BECEF9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.29 81.0188V81.5628L96.3185 84.449L96.3336 83.905L101.29 81.0188Z",
    fill: "#242A31"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3336 83.905L96.3184 84.449L91.3318 81.5779V81.0188L96.3336 83.905Z",
    fill: "#242A31"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0643 84.6455L95.0493 85.1895L90.0928 88.0757V87.5317L95.0643 84.6455Z",
    fill: "#242A31"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0927 87.5317V88.0757L85.0909 85.1895V84.6455L90.0927 87.5317Z",
    fill: "#242A31"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8234 88.2722V88.8162L83.8518 91.7024V91.1584L88.8234 88.2722Z",
    fill: "#242A31"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8518 91.1584V91.7024L78.85 88.8162V88.2722L83.8518 91.1584Z",
    fill: "#242A31"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5826 91.8987V92.4427L77.611 95.3289V94.7849L82.5826 91.8987Z",
    fill: "#242A31"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6109 94.7849V95.3289L72.6091 92.4427V91.8987L77.6109 94.7849Z",
    fill: "#242A31"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3416 95.5254V96.0694L71.37 98.9556V98.4116L76.3416 95.5254Z",
    fill: "#242A31"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M71.37 98.4116V98.9556L66.3682 96.0694V95.5254L71.37 98.4116Z",
    fill: "#242A31"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1007 99.1521V99.6961L65.129 102.582V102.038L70.1007 99.1521Z",
    fill: "#242A31"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M65.129 102.038V102.582L60.1272 99.6961V99.1521L65.129 102.038Z",
    fill: "#242A31"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8598 102.779V103.323L58.8882 106.209V105.665L63.8598 102.779Z",
    fill: "#242A31"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8881 105.665V106.209L53.8864 103.323L53.9015 102.779L58.8881 105.665Z",
    fill: "#242A31"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6189 106.39V106.949L52.6473 109.836V109.292L57.6189 106.39Z",
    fill: "#242A31"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6473 109.292V109.836L47.6605 106.949V106.405L52.6473 109.292Z",
    fill: "#242A31"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3779 110.017V110.576L46.4064 113.462L46.4214 112.918L51.3779 110.017Z",
    fill: "#242A31"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4215 112.918L46.4064 113.462L41.4197 110.576V110.032L46.4215 112.918Z",
    fill: "#242A31"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1371 113.644V114.203L40.1807 117.089V116.53L45.1371 113.644Z",
    fill: "#242A31"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1806 116.53V117.089L35.1788 114.203V113.644L40.1806 116.53Z",
    fill: "#242A31"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8961 117.271V117.83L33.9397 120.716V120.157L38.8961 117.271Z",
    fill: "#242A31"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9397 120.157V120.716L28.9379 117.83V117.271L33.9397 120.157Z",
    fill: "#242A31"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6703 120.897V121.456L27.6987 124.343V123.783L32.6703 120.897Z",
    fill: "#242A31"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6988 123.783V124.343L22.697 121.456V120.897L27.6988 123.783Z",
    fill: "#242A31"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4294 124.524V125.083L21.4579 127.969V127.41L26.4294 124.524Z",
    fill: "#242A31"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4578 127.41V127.969L16.4561 125.083V124.524L21.4578 127.41Z",
    fill: "#242A31"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M107.259 84.7815V85.3406L97.1497 91.2037V90.6597L107.259 84.7815Z",
    fill: "#242A31"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1496 90.6597V91.2037L92.1478 88.3325V87.7734L97.1496 90.6597Z",
    fill: "#242A31"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0312 91.3093L96.0161 91.8684L91.0597 94.7547V94.2107L96.0312 91.3093Z",
    fill: "#242A31"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0598 94.2105V94.7545L86.058 91.8682V91.3242L91.0598 94.2105Z",
    fill: "#242A31"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0776 94.7698V95.3289L85.1061 98.2151V97.656L90.0776 94.7698Z",
    fill: "#242A31"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M85.106 97.656V98.2151L80.1042 95.3289V94.7698L85.106 97.656Z",
    fill: "#242A31"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1239 98.2302V98.7893L79.1523 101.676V101.116L84.1239 98.2302Z",
    fill: "#242A31"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1523 101.116V101.676L74.1505 98.7893V98.2302L79.1523 101.116Z",
    fill: "#242A31"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1699 101.691V102.25L73.1984 105.136V104.577L78.1699 101.691Z",
    fill: "#242A31"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1984 104.577V105.136L68.1967 102.25V101.691L73.1984 104.577Z",
    fill: "#242A31"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M72.216 105.151V105.71L67.2445 108.581V108.037L72.216 105.151Z",
    fill: "#242A31"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2446 108.037V108.581L62.2579 105.71V105.151L67.2446 108.037Z",
    fill: "#242A31"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2624 108.612V109.156L61.2909 112.042L61.306 111.498L66.2624 108.612Z",
    fill: "#242A31"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M61.306 111.498L61.2909 112.042L56.3042 109.156V108.612L61.306 111.498Z",
    fill: "#242A31"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3086 112.072V112.616L55.337 115.502V114.958L60.3086 112.072Z",
    fill: "#242A31"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M55.337 114.958V115.502L50.3503 112.616V112.072L55.337 114.958Z",
    fill: "#242A31"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3547 115.532V116.076L49.3983 118.963V118.419L54.3547 115.532Z",
    fill: "#242A31"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3984 118.419V118.963L44.3966 116.076V115.532L49.3984 118.419Z",
    fill: "#242A31"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4161 118.993V119.537L43.4446 122.423V121.879L48.4161 118.993Z",
    fill: "#242A31"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4445 121.879V122.423L38.4427 119.537V118.993L43.4445 121.879Z",
    fill: "#242A31"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4624 122.438V122.998L37.4908 125.884V125.325L42.4624 122.438Z",
    fill: "#242A31"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4908 125.325V125.884L32.489 122.998V122.454L37.4908 125.325Z",
    fill: "#242A31"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4482 125.944V126.488L27.6686 131.581V131.037L36.4482 125.944Z",
    fill: "#242A31"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6685 131.036V131.58L22.6819 128.694V128.15L27.6685 131.036Z",
    fill: "#242A31"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M113.515 88.3928V88.9368L100.912 96.2657V95.7066L113.515 88.3928Z",
    fill: "#242A31"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M100.912 95.7068V96.2659L95.9104 93.3797V92.8206L100.912 95.7068Z",
    fill: "#242A31"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M99.794 96.3716V96.9156L94.8225 99.8018V99.2578L99.794 96.3716Z",
    fill: "#242A31"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8225 99.2578V99.8018L89.8207 96.9156V96.3716L94.8225 99.2578Z",
    fill: "#242A31"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9159 99.7717V100.331L88.9594 103.217V102.658L93.9159 99.7717Z",
    fill: "#242A31"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9593 102.658V103.217L83.9575 100.331V99.7717L88.9593 102.658Z",
    fill: "#242A31"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0528 103.187V103.731L83.0963 106.617V106.073L88.0528 103.187Z",
    fill: "#242A31"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0963 106.073V106.617L78.0945 103.731V103.187L83.0963 106.073Z",
    fill: "#242A31"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1895 106.602V107.146L77.2179 110.032V109.473L82.1895 106.602Z",
    fill: "#242A31"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M77.218 109.473V110.032L72.2162 107.146V106.587L77.218 109.473Z",
    fill: "#242A31"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3265 110.002V110.561L71.3549 113.432V112.888L76.3265 110.002Z",
    fill: "#242A31"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3548 112.888V113.432L66.353 110.546V110.002L71.3548 112.888Z",
    fill: "#242A31"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4634 113.417V113.961L65.4918 116.847V116.303L70.4634 113.417Z",
    fill: "#242A31"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4918 116.303V116.847L60.49 113.961V113.402L65.4918 116.303Z",
    fill: "#242A31"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6002 116.817L64.5851 117.376L59.6287 120.262V119.703L64.6002 116.817Z",
    fill: "#242A31"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6286 119.703V120.262L54.6268 117.376V116.817L59.6286 119.703Z",
    fill: "#242A31"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7218 120.232V120.776L53.7502 123.662L53.7654 123.118L58.7218 120.232Z",
    fill: "#242A31"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7654 123.118L53.7503 123.662L48.7485 120.776L48.7637 120.232L53.7654 123.118Z",
    fill: "#242A31"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8587 123.632V124.191L47.8872 127.077V126.518L52.8587 123.632Z",
    fill: "#242A31"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8873 126.518V127.077L42.8855 124.191V123.632L47.8873 126.518Z",
    fill: "#242A31"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5877 127.289V127.833L33.9246 135.192V134.648L46.5877 127.289Z",
    fill: "#242A31"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9245 134.648V135.192L28.9227 132.306V131.762L33.9245 134.648Z",
    fill: "#242A31"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M113.364 95.6011V96.1602L110.508 97.8073V97.2633L113.364 95.6011Z",
    fill: "#242A31"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M110.508 97.2633V97.8073L105.597 94.9815L105.612 94.4224L110.508 97.2633Z",
    fill: "#242A31"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M119.696 99.258V99.8171L113.364 96.1602V95.6011L119.696 99.258Z",
    fill: "#242A31"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M125.997 95.6011V96.1602L119.696 99.8171V99.258L125.997 95.6011Z",
    fill: "#242A31"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M104.494 100.86V101.419L99.4919 98.5325V97.9734L104.494 100.86Z",
    fill: "#242A31"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M109.465 97.9734V98.5325L104.494 101.419V100.86L109.465 97.9734Z",
    fill: "#242A31"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M113.485 102.869V103.428L108.483 100.542V99.9832L113.485 102.869Z",
    fill: "#242A31"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M118.456 99.9832V100.542L113.485 103.428V102.869L118.456 99.9832Z",
    fill: "#242A31"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M132.464 99.3335V99.8926L119.877 107.206V106.647L132.464 99.3335Z",
    fill: "#242A31"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M119.877 106.647V107.207L114.875 104.32V103.761L119.877 106.647Z",
    fill: "#242A31"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M103.542 101.419V101.963L98.5852 104.849V104.305L103.542 101.419Z",
    fill: "#242A31"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5852 104.305V104.849L93.5834 101.963V101.419L98.5852 104.305Z",
    fill: "#242A31"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6179 104.864V105.408L92.6464 108.294L92.6615 107.75L97.6179 104.864Z",
    fill: "#242A31"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6616 107.75L92.6464 108.294L87.6447 105.408L87.6598 104.864L92.6616 107.75Z",
    fill: "#242A31"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7097 108.294L91.6946 108.854L86.7382 111.74V111.196L91.7097 108.294Z",
    fill: "#242A31"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7381 111.196V111.74L81.7363 108.854V108.294L86.7381 111.196Z",
    fill: "#242A31"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7861 111.74V112.299L80.8145 115.185V114.626L85.7861 111.74Z",
    fill: "#242A31"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8144 114.626V115.185L75.8126 112.299V111.74L80.8144 114.626Z",
    fill: "#242A31"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8623 115.185V115.729L74.8907 118.615V118.071L79.8623 115.185Z",
    fill: "#242A31"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8908 118.071V118.615L69.889 115.729V115.185L74.8908 118.071Z",
    fill: "#242A31"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9389 118.63V119.174L68.9674 122.061V121.517L73.9389 118.63Z",
    fill: "#242A31"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9674 121.517V122.061L63.9656 119.174V118.63L68.9674 121.517Z",
    fill: "#242A31"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0153 122.061V122.62L63.0437 125.506V124.947L68.0153 122.061Z",
    fill: "#242A31"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0437 124.947V125.506L58.0419 122.62V122.061L63.0437 124.947Z",
    fill: "#242A31"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0919 125.506V126.065L57.1202 128.951V128.392L62.0919 125.506Z",
    fill: "#242A31"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1202 128.392V128.951L52.1184 126.065V125.506L57.1202 128.392Z",
    fill: "#242A31"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1681 128.951V129.495L51.1965 132.381V131.837L56.1681 128.951Z",
    fill: "#242A31"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1966 131.837V132.381L46.1948 129.495V128.951L51.1966 131.837Z",
    fill: "#242A31"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9878 132.548V133.092L40.1655 138.804V138.244L49.9878 132.548Z",
    fill: "#242A31"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1655 138.244V138.803L35.1637 135.917V135.358L40.1655 138.244Z",
    fill: "#242A31"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M112.533 103.428V103.988L107.561 106.874V106.315L112.533 103.428Z",
    fill: "#242A31"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M107.561 106.315V106.874L102.559 103.988V103.428L107.561 106.315Z",
    fill: "#242A31"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M106.609 106.874V107.418L101.638 110.304V109.76L106.609 106.874Z",
    fill: "#242A31"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M101.638 109.76V110.304L96.6359 107.418V106.874L101.638 109.76Z",
    fill: "#242A31"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M100.686 110.319V110.863L95.7141 113.75L95.7291 113.206L100.686 110.319Z",
    fill: "#242A31"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7291 113.206L95.7141 113.75L90.7123 110.863L90.7273 110.319L95.7291 113.206Z",
    fill: "#242A31"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M94.762 113.75V114.309L89.7904 117.195V116.636L94.762 113.75Z",
    fill: "#242A31"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7905 116.636V117.195L84.7887 114.309V113.75L89.7905 116.636Z",
    fill: "#242A31"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8385 117.195V117.754L83.8669 120.64L83.8821 120.081L88.8385 117.195Z",
    fill: "#242A31"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M83.882 120.081L83.8669 120.64L78.8651 117.754L78.8802 117.195L83.882 120.081Z",
    fill: "#242A31"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9299 120.64L82.9148 121.184L77.9584 124.07V123.526L82.9299 120.64Z",
    fill: "#242A31"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9585 123.526V124.07L72.9567 121.184V120.64L77.9585 123.526Z",
    fill: "#242A31"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0064 124.085V124.629L72.0348 127.516V126.972L77.0064 124.085Z",
    fill: "#242A31"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0349 126.972V127.516L67.0331 124.629V124.085L72.0349 126.972Z",
    fill: "#242A31"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0829 127.516L71.0678 128.075L66.1113 130.961V130.402L71.0829 127.516Z",
    fill: "#242A31"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1113 130.402V130.961L61.1095 128.075V127.516L66.1113 130.402Z",
    fill: "#242A31"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1592 130.961V131.52L60.1876 134.406V133.847L65.1592 130.961Z",
    fill: "#242A31"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1877 133.847V134.406L55.1859 131.505V130.961L60.1877 133.847Z",
    fill: "#242A31"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0696 134.497V135.041L46.4065 142.4L46.4215 141.856L59.0696 134.497Z",
    fill: "#242A31"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4215 141.856L46.4065 142.4L41.4047 139.514L41.4197 138.97L46.4215 141.856Z",
    fill: "#242A31"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M118.743 107.312V107.856L113.772 110.757V110.198L118.743 107.312Z",
    fill: "#242A31"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M113.772 110.198V110.757L108.77 107.856V107.312L113.772 110.198Z",
    fill: "#242A31"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M112.865 110.727V111.286L107.894 114.173V113.614L112.865 110.727Z",
    fill: "#242A31"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M107.894 113.614V114.173L102.892 111.286V110.727L107.894 113.614Z",
    fill: "#242A31"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M106.987 114.142V114.701L102.016 117.588V117.029L106.987 114.142Z",
    fill: "#242A31"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M102.015 117.029V117.588L97.0137 114.686V114.142L102.015 117.029Z",
    fill: "#242A31"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M101.109 117.558V118.102L96.1371 121.003V120.444L101.109 117.558Z",
    fill: "#242A31"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1372 120.444V121.003L91.1354 118.102V117.558L96.1372 120.444Z",
    fill: "#242A31"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2608 120.958L95.2457 121.517L72.715 134.618V134.059L95.2608 120.958Z",
    fill: "#242A31"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7149 134.059V134.618L67.7131 131.732V131.173L72.7149 134.059Z",
    fill: "#242A31"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5363 134.739V135.298L66.5647 138.184V137.64L71.5363 134.739Z",
    fill: "#242A31"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5647 137.64V138.184L61.5629 135.298V134.739L66.5647 137.64Z",
    fill: "#242A31"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5369 138.229V138.774L52.8738 146.133V145.589L65.5369 138.229Z",
    fill: "#242A31"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8739 145.589V146.133L47.8721 143.246V142.702L52.8739 145.589Z",
    fill: "#242A31"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M101.29 81.0186L96.3336 83.9048L91.3318 81.0186L96.3033 78.1323L101.29 81.0186Z",
    fill: "#37404A"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0643 84.6453L90.0927 87.5315L85.0909 84.6453L90.0625 81.759L95.0643 84.6453Z",
    fill: "#37404A"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8234 88.272L83.8518 91.1582L78.85 88.272L83.8215 85.3857L88.8234 88.272Z",
    fill: "#37404A"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5825 91.8987L77.6109 94.7849L72.6091 91.8987L77.5808 89.0125L82.5825 91.8987Z",
    fill: "#37404A"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3416 95.5254L71.37 98.4116L66.3682 95.5254L71.3398 92.6392L76.3416 95.5254Z",
    fill: "#37404A"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1006 99.1519L65.129 102.038L60.1272 99.1519L65.0988 96.2656L70.1006 99.1519Z",
    fill: "#37404A"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8598 102.779L58.8882 105.665L53.9015 102.779L58.858 99.8923L63.8598 102.779Z",
    fill: "#37404A"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6188 106.39L52.6473 109.291L47.6605 106.405L52.6322 103.519L57.6188 106.39Z",
    fill: "#37404A"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M51.378 110.017L46.4215 112.918L41.4197 110.032L46.3913 107.131L51.378 110.017Z",
    fill: "#37404A"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M45.137 113.644L40.1806 116.53L35.1788 113.644L40.1504 110.772L45.137 113.644Z",
    fill: "#37404A"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8961 117.27L33.9397 120.157L28.9379 117.27L33.9094 114.384L38.8961 117.27Z",
    fill: "#37404A"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6703 120.897L27.6988 123.783L22.697 120.897L27.6686 118.01L32.6703 120.897Z",
    fill: "#37404A"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4294 124.524L21.4578 127.41L16.4561 124.524L21.4276 121.637L26.4294 124.524Z",
    fill: "#37404A"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M107.259 84.7812L97.1496 90.6595L92.1478 87.7733L102.272 81.895L107.259 84.7812Z",
    fill: "#37404A"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0313 91.3093L91.0598 94.2107L86.058 91.3244L91.0295 88.4231L96.0313 91.3093Z",
    fill: "#37404A"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0776 94.7698L85.106 97.656L80.1042 94.7698L85.0758 91.8835L90.0776 94.7698Z",
    fill: "#37404A"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1238 98.2302L79.1523 101.116L74.1505 98.2302L79.122 95.344L84.1238 98.2302Z",
    fill: "#37404A"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M78.17 101.69L73.1984 104.577L68.1967 101.69L73.1682 98.8042L78.17 101.69Z",
    fill: "#37404A"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2161 105.151L67.2446 108.037L62.2579 105.151L67.2143 102.265L72.2161 105.151Z",
    fill: "#37404A"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2624 108.612L61.306 111.498L56.3042 108.612L61.2606 105.725L66.2624 108.612Z",
    fill: "#37404A"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3085 112.072L55.337 114.958L50.3503 112.072L55.3219 109.186L60.3085 112.072Z",
    fill: "#37404A"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3548 115.532L49.3984 118.419L44.3966 115.532L49.3681 112.646L54.3548 115.532Z",
    fill: "#37404A"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4161 118.993L43.4445 121.879L38.4427 118.993L43.4143 116.107L48.4161 118.993Z",
    fill: "#37404A"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4623 122.438L37.4908 125.325L32.489 122.454L37.4605 119.552L42.4623 122.438Z",
    fill: "#37404A"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 125.944L27.6685 131.037L22.6819 128.15L31.4463 123.058L36.4481 125.944Z",
    fill: "#37404A"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M113.515 88.3928L100.912 95.7066L95.9104 92.8204L108.513 85.5066L113.515 88.3928Z",
    fill: "#37404A"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M99.794 96.3716L94.8225 99.2578L89.8207 96.3716L94.7922 93.4854L99.794 96.3716Z",
    fill: "#37404A"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9158 99.7715L88.9593 102.658L83.9575 99.7715L88.914 96.8853L93.9158 99.7715Z",
    fill: "#37404A"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0528 103.187L83.0963 106.073L78.0945 103.187L83.051 100.301L88.0528 103.187Z",
    fill: "#37404A"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1896 106.602L77.218 109.473L72.2162 106.587L77.1878 103.7L82.1896 106.602Z",
    fill: "#37404A"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3264 110.002L71.3548 112.888L66.353 110.002L71.3247 107.115L76.3264 110.002Z",
    fill: "#37404A"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4633 113.417L65.4918 116.303L60.49 113.402L65.4615 110.531L70.4633 113.417Z",
    fill: "#37404A"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6002 116.817L59.6286 119.703L54.6268 116.817L59.5984 113.931L64.6002 116.817Z",
    fill: "#37404A"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7219 120.232L53.7655 123.118L48.7637 120.232L53.7201 117.346L58.7219 120.232Z",
    fill: "#37404A"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8588 123.632L47.8873 126.518L42.8855 123.632L47.857 120.746L52.8588 123.632Z",
    fill: "#37404A"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5877 127.289L33.9245 134.648L28.9227 131.762L41.5859 124.403L46.5877 127.289Z",
    fill: "#37404A"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M125.997 95.6008L119.695 99.2577L113.364 95.6008L110.508 97.2631L105.612 94.4222L114.754 89.103L125.997 95.6008Z",
    fill: "#37404A"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M109.465 97.9734L104.494 100.86L99.4919 97.9734L104.463 95.0872L109.465 97.9734Z",
    fill: "#37404A"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M118.456 99.9832L113.485 102.869L108.483 99.9832L113.455 97.0969L118.456 99.9832Z",
    fill: "#37404A"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M132.464 99.3333L119.877 106.647L114.875 103.761L127.463 96.447L132.464 99.3333Z",
    fill: "#37404A"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M103.542 101.418L98.5852 104.305L93.5834 101.418L98.5399 98.5322L103.542 101.418Z",
    fill: "#37404A"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M97.618 104.864L92.6616 107.75L87.6598 104.864L92.6162 101.978L97.618 104.864Z",
    fill: "#37404A"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7097 108.294L86.7381 111.196L81.7363 108.294L86.7079 105.408L91.7097 108.294Z",
    fill: "#37404A"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M85.786 111.74L80.8144 114.626L75.8126 111.74L80.7843 108.853L85.786 111.74Z",
    fill: "#37404A"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8624 115.185L74.8908 118.071L69.889 115.185L74.8606 112.299L79.8624 115.185Z",
    fill: "#37404A"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9389 118.63L68.9674 121.516L63.9656 118.63L68.9371 115.744L73.9389 118.63Z",
    fill: "#37404A"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0153 122.061L63.0437 124.947L58.0419 122.061L63.0135 119.174L68.0153 122.061Z",
    fill: "#37404A"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0918 125.506L57.1202 128.392L52.1184 125.506L57.09 122.619L62.0918 125.506Z",
    fill: "#37404A"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1681 128.951L51.1966 131.837L46.1948 128.951L51.1664 126.065L56.1681 128.951Z",
    fill: "#37404A"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9877 132.548L40.1655 138.245L35.1637 135.358L44.9859 129.661L49.9877 132.548Z",
    fill: "#37404A"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M112.533 103.428L107.561 106.314L102.559 103.428L107.531 100.542L112.533 103.428Z",
    fill: "#37404A"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M106.609 106.874L101.638 109.76L96.6359 106.874L101.607 103.988L106.609 106.874Z",
    fill: "#37404A"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M100.686 110.319L95.7291 113.205L90.7273 110.319L95.6838 107.433L100.686 110.319Z",
    fill: "#37404A"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7621 113.75L89.7905 116.636L84.7887 113.75L89.7603 110.863L94.7621 113.75Z",
    fill: "#37404A"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8384 117.195L83.882 120.081L78.8802 117.195L83.8367 114.308L88.8384 117.195Z",
    fill: "#37404A"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M82.93 120.64L77.9585 123.526L72.9567 120.64L77.9282 117.754L82.93 120.64Z",
    fill: "#37404A"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0065 124.085L72.0349 126.971L67.0331 124.085L72.0047 121.184L77.0065 124.085Z",
    fill: "#37404A"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0828 127.516L66.1113 130.402L61.1095 127.516L66.081 124.629L71.0828 127.516Z",
    fill: "#37404A"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1592 130.961L60.1877 133.847L55.1859 130.961L60.1574 128.075L65.1592 130.961Z",
    fill: "#37404A"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0696 134.497L46.4215 141.856L41.4197 138.97L54.0678 131.611L59.0696 134.497Z",
    fill: "#37404A"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M118.743 107.312L113.772 110.198L108.77 107.312L113.742 104.426L118.743 107.312Z",
    fill: "#37404A"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M112.865 110.727L107.894 113.613L102.892 110.727L107.863 107.841L112.865 110.727Z",
    fill: "#37404A"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M106.987 114.142L102.015 117.029L97.0137 114.142L101.985 111.256L106.987 114.142Z",
    fill: "#37404A"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M101.109 117.557L96.1372 120.444L91.1354 117.557L96.1069 114.671L101.109 117.557Z",
    fill: "#37404A"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2607 120.957L72.7149 134.059L67.7131 131.172L90.2589 118.071L95.2607 120.957Z",
    fill: "#37404A"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5363 134.739L66.5647 137.64L61.5629 134.739L66.5345 131.853L71.5363 134.739Z",
    fill: "#37404A"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M65.537 138.229L52.8739 145.589L47.8721 142.702L60.5352 135.343L65.537 138.229Z",
    fill: "#37404A"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M118.2 128.694C118.079 128.876 117.897 129.042 117.64 129.193L98.1168 140.466C97.1497 141.025 95.5781 141.025 94.611 140.466L85.499 135.207C85.2421 135.056 85.0608 134.89 84.9399 134.724C84.5924 134.21 84.7737 133.605 85.499 133.197L105.023 121.924C105.99 121.365 107.561 121.365 108.513 121.924L117.625 127.183C118.336 127.591 118.517 128.196 118.184 128.709L118.2 128.694Z",
    fill: "#98A4E0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M118.199 128.694C118.078 128.876 117.897 129.042 117.64 129.193L98.1167 140.466C97.1496 141.025 95.578 141.025 94.6109 140.466L85.4989 135.207C85.242 135.056 85.0607 134.89 84.9398 134.724C85.0607 134.542 85.242 134.376 85.4989 134.225L105.023 122.952C105.99 122.393 107.561 122.393 108.513 122.952L117.625 128.211C117.882 128.347 118.063 128.513 118.184 128.694H118.199Z",
    fill: "#BECEF9"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0136 48.0009L73.954 44.48C71.9593 43.3164 69.1789 43.4827 66.1264 45.2507C65.5824 45.568 65.0384 45.9307 64.5095 46.3236L70.5691 49.8445C71.098 49.4516 71.6269 49.0889 72.186 48.7716C75.2385 47.0036 78.0189 46.8373 80.0136 48.0009Z",
    fill: "#CDDCFB"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6996 65.5148L32.64 61.9939C32.1262 63.8375 31.7938 65.681 31.6427 67.4792L37.7023 71.0001C37.8383 69.2019 38.1858 67.3583 38.6996 65.5148Z",
    fill: "#CDDCFB"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7174 71.0001L31.6578 67.4792C31.6125 68.1441 31.5823 68.7939 31.5823 69.4437C31.5823 70.4259 31.6578 71.3477 31.7787 72.2241L37.8382 75.7451C37.7173 74.8686 37.6418 73.9468 37.6418 72.9646C37.6418 72.3148 37.6721 71.665 37.7174 71.0001Z",
    fill: "#CDDCFB"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2491 44.1928C45.0464 49.5119 37.6116 62.3866 37.6419 72.9644C37.6419 73.9466 37.7174 74.8684 37.8383 75.7449C37.3396 75.9262 36.8108 76.1529 36.2819 76.4702C31.8846 79.0089 28.3183 85.1742 28.3334 90.2365C28.3334 95.2987 31.9298 97.3387 36.3272 94.8L72.2464 74.0675C78.3211 70.5617 83.2323 62.0542 83.2171 55.0728C83.202 48.0915 78.2607 45.2808 72.186 48.7866C71.642 49.1039 71.098 49.4666 70.5691 49.8595C68.9069 42.1981 62.2278 39.6141 54.2491 44.223V44.1928Z",
    fill: "#EFF6FE"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6331 90.2212C29.6331 85.6576 32.9575 79.8701 36.9318 77.5732C37.3851 77.3163 37.8384 77.1047 38.2616 76.9536L39.274 76.6061L39.1229 75.5483C39.002 74.7323 38.9416 73.8558 38.9416 72.9492C38.9114 62.8096 46.074 50.4033 54.899 45.3109C57.2865 43.9357 59.6589 43.1953 61.7291 43.1953C65.658 43.1953 68.3478 45.6433 69.315 50.1011L69.7381 52.0656L71.3549 50.8567C71.8385 50.494 72.3372 50.1616 72.8359 49.8744C74.347 48.998 75.8278 48.5447 77.1274 48.5447C80.1194 48.5447 81.9176 50.9775 81.9327 55.0576C81.9478 61.51 77.2181 69.6852 71.6119 72.934L35.6926 93.6665C34.65 94.271 33.6375 94.5883 32.7611 94.5883C30.8117 94.5883 29.6331 92.9563 29.6331 90.2212ZM73.2589 50.63C72.7905 50.902 72.3221 51.2193 71.8536 51.5518L69.179 53.5464L68.4687 50.2824C67.5923 46.2629 65.2047 44.0415 61.7291 44.0415C59.81 44.0415 57.5887 44.7366 55.322 46.0362C46.7238 50.9927 39.7576 63.0665 39.7878 72.934C39.7878 73.7954 39.8482 74.6265 39.9691 75.4123L40.226 77.1652L38.5487 77.7394C38.1709 77.8754 37.778 78.0567 37.37 78.2985C33.6375 80.4594 30.4793 85.9145 30.4944 90.2061C30.4944 91.5208 30.7966 93.7119 32.7762 93.7119C33.5015 93.7119 34.3628 93.4399 35.2846 92.911L71.2038 72.1785C76.5834 69.0656 81.1167 61.2229 81.1016 55.0424C81.1016 51.5064 79.6208 49.3909 77.1425 49.3909C75.9941 49.3909 74.6643 49.814 73.2741 50.6149L73.2589 50.63Z",
    fill: "#CDDCFB"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M24.601 91.8233L30.6605 95.3442C29.225 94.513 28.3485 92.745 28.3334 90.2215C28.3334 85.1592 31.8846 78.9939 36.2819 76.4552C36.8108 76.153 37.3245 75.9112 37.8383 75.7299L31.7788 72.209C31.2802 72.3903 30.7512 72.617 30.2223 72.9343C25.825 75.473 22.2587 81.6383 22.2739 86.7006C22.2739 89.209 23.1655 90.977 24.601 91.8233Z",
    fill: "#D4E2FC"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1895 40.6719C52.8135 37.9972 57.0144 37.7554 60.0366 39.5083L66.0962 43.0292C63.074 41.2763 58.8731 41.5181 54.2491 44.1927C45.0464 49.5119 37.6116 62.3866 37.6419 72.9644C37.6419 73.9466 37.7174 74.8684 37.8383 75.7448L31.7788 72.2239C31.6579 71.3475 31.5824 70.4257 31.5824 69.4435C31.5521 58.8657 38.9868 45.991 48.1895 40.6719Z",
    fill: "#CDDCFB"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7265 64.5022L60.0518 60.5128L61.442 59.7271C60.6411 58.6542 59.3416 58.2613 57.8002 58.6844C54.914 59.4853 51.9673 62.8399 50.7735 66.6782C50.5317 67.464 49.882 68.1289 49.3229 68.1742C48.7638 68.2195 48.5069 67.6151 48.7487 66.8293C50.3807 61.5857 54.4153 57.007 58.3442 55.919C60.8829 55.2239 62.9229 56.1306 63.8901 58.367L65.522 57.4604L62.7113 64.5324L62.7265 64.5022Z",
    fill: "#CDDCFB"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7842 76.3796L49.1868 69.2924L52.2695 72.768L50.7886 73.7503C51.5744 74.9743 52.9193 75.4427 54.5664 74.9894C57.2713 74.2489 60.1576 71.0907 61.4269 67.4942C61.6989 66.7085 62.3638 66.0738 62.9078 66.0889C63.4518 66.0889 63.6633 66.7387 63.3913 67.5244C61.9709 71.544 59.0846 75.1556 56.0624 76.8934C55.3824 77.2862 54.7024 77.5885 54.0224 77.7698C51.4686 78.48 49.4286 77.5582 48.4615 75.2916L46.8143 76.3796H46.7842Z",
    fill: "#CDDCFB"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M33.592 90.2666L39.8481 86.6702V88.9822L33.592 92.5786V90.2666Z",
    fill: "#3C6FF7"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M38.201 87.9395L39.425 87.2444V87.6524L38.201 88.3475V87.9395Z",
    fill: "#ED1C24"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3601 89.5866L37.6569 88.2568V88.6648L35.3601 89.9946V89.5866Z",
    fill: "#ED1C24"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7102 89.9646V90.3575L34 90.7655V90.3726L34.7102 89.9646Z",
    fill: "#ED1C24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualMachines);
export default __webpack_public_path__ + "static/media/virtual-machines.de0351bb1f55fb5a50677e03499c17bb.svg";
export { ForwardRef as ReactComponent };